/**
 * Geocoding utility using Google Geocoding API via Cloud Function
 */
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';

/**
 * Geocode an address to get latitude and longitude
 * @param {string} address - The address to geocode
 * @returns {Promise<{lat: number, lng: number, displayName: string} | null>}
 */
export const geocodeAddress = async (address) => {
    if (!address || !address.trim()) {
        console.error('Geocoding error: No address provided');
        return null;
    }

    try {
        const forwardGeocode = httpsCallable(functions, 'forwardGeocode');
        const response = await forwardGeocode({ address: address.trim() });
        const data = response.data;

        if (data.status === 'OK' && data.results && data.results.length > 0) {
            const result = data.results[0];
            return {
                lat: result.geometry.location.lat,
                lng: result.geometry.location.lng,
                displayName: result.formatted_address
            };
        } else {
            console.warn('Geocoding: No results found for address:', address);
            return null;
        }
    } catch (error) {
        console.error('Geocoding error:', error);
        return null;
    }
};
